import '.a{display:flex;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.b4{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.b5{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.b6{margin-top:2rem;}.ssr-plugin'
import '.b7{margin-bottom:5rem;}.ssr-plugin'
import '.b8{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="a f b e b4"
      >
        <DashboardNavBar />
        <div className="b5 a e ab b6 b7 b8"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
